import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { showBinary, showCasinoControlLink, casinoList, lotusIndex, showAdminBannerLink, showClubGames, showNewUserPageServerSidePagination, showRebateBonus } from './configs/casinoShowList';

import Auth from './components/auth'
import Dashboard from './components/dashboard';
import Users from './components/users';
import UsersNew from './components/usersNew';
import AddUser from './components/addUser';
import ImportEvent from './components/importEvent';
import ChangePassword from './components/changePassword';
import SetPassword from './components/setPassword';
import MasterEventTemplate from './components/masterEventTemplate';
import CurrencyMaster from './components/currencyMaster';
import EventControl from './components/eventControl';
import MarketResults from './components/marketResults';
import OrderHistory from './components/orderHistory';
import EventBetHistory from './components/eventBetHistory';
import UnSetteledBets from './components/unSetteledBets';
import GeneralReports from './components/generalReports';
import GameReports from './components/gameReports';
import UserSettlement from './components/userSettlement';
import MasterSettlement from './components/masterSettlement';
import CasinoReports from './components/casinoReports';
import ProfitLoss from './components/profitLoss';
import CasinoResultReports from './components/casinoResultReports';
import ApiErrorReports from './components/apiError';
import ApiUserReports from './components/apiUser';
import BetHistory from './components/betHistory';
import LiveBets from './components/liveBets';
import UserDetailReport from './components/userDetailReport';
import TransactionsReports from './components/transactions';
import SportAnalysis from './components/sportanalysis';
import SportAnalysisUsers from './components/sportanalysisusers';
import BinaryAnalysis from './components/binaryanalysis';
import BinaryAnalysisUsers from './components/binaryanalysisusers';
import LiveMarkets from './components/livemarkets';
import MyTransaction from './components/MyTransaction';
import AccountStatement from './components/accountStatement';
import SettlementReport from './components/settlementReport';
import MarqueeSetting from './components/marqueeMaster';
import CasinoAnalysis from './components/casinoanalysis';
import CasinoAnalysisUsers from './components/casinoanalysisusers';
import GameControl from './components/sportsbetlock';
import CasinoControl from './components/casinocontrol';
import RealGames from './components/realgames';
import EventPnLReport from './components/eventPnLReport';
import Casinoanalysisusersnew from './components/casinoanalysisusersnew';
import OnlyCasinoBetsCall from './components/onlycasinobetscall';
import CasinoReport from './components/casinoReport';
import SportsRevenue from './components/sportsRevenue';
import Banner from './components/banner';
import AgentMaster from './components/agentMaster';
import CuttingHistory from './components/cuttingHistory';
import RebateBonus from './components/rebateBonus';
import Affiliates from './components/affiliates';
import AddAffiliates from './components/addAffiliates';
import AffiliateRequest from './components/affiliateRequest';
import AffiliateApprovedList from './components/affiliateApprovedList';
import AffiliateClientList from './components/affiliateClientList';
import Kyc from './components/kyc';
import AffiliateReport from './components/affiliateReport';
import ActivityLogs from './components/activityLogs';
import AffiliateClientReport from './components/affiliateClientReport';


class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptions: {
        market_room: [],
        user_room: [],
        site_room: [],
        x_score_room: [],
        score_room: [],
      },
      isOfficeChannel: false,
      notification: {}
    };
  }

  async componentDidMount() {
    let userAccData = !!localStorage.getItem("userAccData") ? JSON.parse(localStorage.getItem("userAccData")) : "";
    let isOfficeChannel = !!userAccData ? userAccData.username === 'office' || (!!userAccData.parents && userAccData.parents.includes('office')) : false;

    this.setState({
      isOfficeChannel: isOfficeChannel
    });

    //   if (result.token) {
    //     let data = {
    //        token: result.token
    //     }
    //     localStorage.setItem("userAuthDetail", JSON.stringify(data))
    //     let velidateData = await authServices.velidateToken()
    //     if (!!velidateData.role && velidateData.role !== "Client") {
    //        localStorage.setItem("tokenData", JSON.stringify(velidateData))
    //        if (velidateData.pwdch) {
    //           this.props.history.push("/setpassword");
    //        } else {
    //           this.props.history.push("/dashboard");
    //        }
    //     } else if (!!velidateData.role && velidateData.role === "Client") {
    //        this.props.notify("Client user is not allow to access this portal.", "error")
    //     } else {
    //        this.props.notify(!!velidateData && !!velidateData.exception ? velidateData.exception.message : "", "error")
    //     }
    //  } else {
    //     this.props.notify(!!result && !!result.exception ? result.exception.message : "", "error")
    //  }
  }

  setIsOfficeChannel(officeChannel = false) {
    this.setState({
      isOfficeChannel: officeChannel
    });
  }

  subscribed(type, id) {
    let subscriptions = this.state.subscriptions
    if (subscriptions[type].indexOf(id) === -1) {
      subscriptions[type].push(id)
    }
    this.setState({ subscriptions: subscriptions })
  }

  componentWillUnmount() {
    // this.props.socket.off()
  }


  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/" render={(props) => <Auth {...props} notify={this.props.notify} setIsOfficeChannel={(officeChannel) => this.setIsOfficeChannel(officeChannel)} />} exact></Route>
          <Route path="/auth" render={(props) => <Auth {...props} notify={this.props.notify} setIsOfficeChannel={(officeChannel) => this.setIsOfficeChannel(officeChannel)} />} exact></Route>
          <Route path="/dashboard" render={(props) => <Dashboard {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/affiliateRequest" render={(props) => <AffiliateRequest {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/affiliateList" render={(props) => <AffiliateApprovedList {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/affiliateList/:usernm" render={(props) => <AffiliateApprovedList {...props} notify={this.props.notify} />} exact></Route>

          <Route path="/affiliateClientList" render={(props) => <AffiliateClientList {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/changepassword" render={(props) => <ChangePassword {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/kyc" render={(props) => <Kyc {...props} notify={this.props.notify} />} exact></Route>
          
          {showNewUserPageServerSidePagination && <Route path="/clients" render={(props) => <UsersNew {...props} notify={this.props.notify} />} exact></Route>}
          {showNewUserPageServerSidePagination && <Route path="/clients/:user_id" render={(props) => <UsersNew {...props} notify={this.props.notify} />} exact></Route>}
          {!showNewUserPageServerSidePagination && <Route path="/clients" render={(props) => <Users {...props} notify={this.props.notify} />} exact></Route>}
          {!showNewUserPageServerSidePagination && <Route path="/clients/:user_id" render={(props) => <Users {...props} notify={this.props.notify} />} exact></Route>}
          <Route path="/addclient" render={(props) => <AddUser {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/editclient/:userId" render={(props) => <AddUser {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/importevent" render={(props) => <ImportEvent {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/setpassword" render={(props) => <SetPassword {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/eventtemplate" render={(props) => <MasterEventTemplate {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/currencymaster" render={(props) => <CurrencyMaster {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/eventcontrol" render={(props) => <EventControl {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/marketresults" render={(props) => <MarketResults {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/orderhistory" render={(props) => <OrderHistory {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/eventbethistory" render={(props) => <EventBetHistory {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/currentbets" render={(props) => <UnSetteledBets {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/generalreports" render={(props) => <GeneralReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/gamereports" render={(props) => <GameReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/usersettlement" render={(props) => <UserSettlement {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/mastersettlement" render={(props) => <MasterSettlement {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/casinoreports" render={(props) => <CasinoReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/profitloss" render={(props) => <ProfitLoss {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/casinoresultreports" render={(props) => <CasinoResultReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/apierror" render={(props) => <ApiErrorReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/apiuser" render={(props) => <ApiUserReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/apiuser/:user_id" render={(props) => <ApiUserReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/userdetail" render={(props) => <UserDetailReport {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/bethistory" render={(props) => <BetHistory {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/livebets" render={(props) => <LiveBets {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/transaction" render={(props) => <TransactionsReports {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/sportanalysis" render={(props) => <SportAnalysis {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/sportanalysis/:event_id" render={(props) => <SportAnalysisUsers {...props} notify={this.props.notify} />} exact></Route>
          {showBinary &&
            <Route path="/binaryanalysis" render={(props) => <BinaryAnalysis {...props} notify={this.props.notify} />} exact></Route>
          }
          {showBinary &&
            <Route path="/binaryanalysis/:event_id" render={(props) => <BinaryAnalysisUsers {...props} notify={this.props.notify} />} exact></Route>
          }

          <Route path="/livemarkets" render={(props) => <LiveMarkets {...props} notify={this.props.notify} />} exact></Route>
          {/* <Route path="/mytransaction" render={(props) => <MyTransaction {...props} notify={this.props.notify} />} exact></Route>       */}
          <Route path="/accountstatement" render={(props) => <AccountStatement {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/settlementreport" render={(props) => <SettlementReport {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/marqueesettings" render={(props) => <MarqueeSetting {...props} notify={this.props.notify} />} exact></Route>
          {casinoList[lotusIndex].show &&
            <Route path="/casinoanalysis" render={(props) => <CasinoAnalysis {...props} notify={this.props.notify} />} exact></Route>
          }
          {/* <Route path="/casinoanalysisuser/:casinoId" render={(props) => <CasinoAnalysisUsers {...props} notify={this.props.notify} />} exact></Route> */}
          <Route path="/casinoanalysisuser/:casinoId" render={(props) => <Casinoanalysisusersnew {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/gamebetlock" render={(props) => <GameControl {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/gamebetlock/:user_id" render={(props) => <GameControl {...props} notify={this.props.notify} />} exact></Route>
          {showCasinoControlLink &&
            <Route path="/casinocontrol" render={(props) => <CasinoControl {...props} notify={this.props.notify} />} exact></Route>
          }
          {showCasinoControlLink &&
            <Route path="/casinocontrol/:user_id" render={(props) => <CasinoControl {...props} notify={this.props.notify} />} exact></Route>
          }
          <Route path="/eventPnLReport" render={(props) => <EventPnLReport {...props} notify={this.props.notify} />} exact></Route>
          {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && <Route path="/clubgames" render={(props) => <RealGames {...props} notify={this.props.notify} />} exact></Route>}
          {/* <Route path="/gamecontrol/:userId" render={(props) => <GameControl {...props} notify={this.props.notify} />} exact></Route> */}
          <Route path="/onlycasinobetscall" render={(props) => <OnlyCasinoBetsCall {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/casinoreport" render={(props) => <CasinoReport {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/sportsrevenue" render={(props) => <SportsRevenue {...props} notify={this.props.notify} />} exact></Route>

          {showAdminBannerLink &&
            <Route path="/banner" render={(props) => <Banner {...props} notify={this.props.notify} />} exact></Route>}
          <Route path="/agentmaster" render={(props) => <AgentMaster {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/cuttinghistory" render={(props) => <CuttingHistory {...props} notify={this.props.notify} />} exact></Route>
          {((showRebateBonus.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showRebateBonus.show) &&
            <Route path="/rebatebonus" render={(props) => <RebateBonus {...props} notify={this.props.notify} />} exact></Route>
          }
          <Route path="/affiliates" render={(props) => <Affiliates {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/addaffiliates" render={(props) => <AddAffiliates {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/affiliateReport" render={(props) => <AffiliateReport {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/affiliateReport/:userId" render={(props) => <AffiliateReport {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/affiliateClientReport" render={(props) => <AffiliateClientReport {...props} notify={this.props.notify} />} exact></Route>
          <Route path="/activitylogs" render={(props) => <ActivityLogs {...props} notify={this.props.notify} />} exact></Route>
          
        </Switch>
      </BrowserRouter>
    )
  }
};
export default Routes;